import React from "react"
import { ReflectionActionsEnum } from "../../Shared/ReflectionActionsEnum"
import classes from './ReflectionEmojiType.module.css'
import VeryHappy from '../../../assests/reflection/1.png';
import Happy from '../../../assests/reflection/2.png';
import UnHappy from '../../../assests/reflection/3.png';
import Sad from '../../../assests/reflection/4.png';
import VerySad from '../../../assests/reflection/5.png';
import Lines from '../../../assests/reflection/lines.png';
import { ReflectionEmojiTypeEnum } from "../../Shared/ReflectionEmojiTypeEnum";
import { calculatePercentage } from "../../Shared/ReportPercentageCalculation";

const ReflectionEmojiType = ({ action, question = {}, isStudent, answerValue, setAnswerValue }) => {
    const emojies = [VeryHappy, Happy, UnHappy, Sad, VerySad];

    switch (action) {
        case ReflectionActionsEnum.CRUD:
            return (
                <div className={classes.CreateType}>
                    <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                    <div className={classes.Emojies}>
                        {emojies.map((emoji, index) =>
                            <img className={classes.Emoji} key={index} src={emoji} />
                        )}
                    </div>
                </div>
            )

        case ReflectionActionsEnum.View:
            return (
                <div className={classes.CreateType}>
                    <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                    <div className={classes.Emojies}>
                        {emojies.map((emoji, index) => {
                            const emojiIndex = Object.values(ReflectionEmojiTypeEnum).find(emoji => emoji === emojies.length - index)
                            return <img
                                className={`${classes.EmojiView} ${emojiIndex === answerValue ? classes.CurrentEmoji : null} ${isStudent && classes.SelectEmoji}`}
                                key={index}
                                src={emoji}
                                onClick={() => { isStudent && setAnswerValue(emojiIndex) }}
                            />
                        })}
                    </div>
                </div>)

        case ReflectionActionsEnum.Report:
            return (
                <div className={classes.ReportType}>
                    <p className={classes.ReportQuestion}>{question.name}</p>
                    <div className={classes.EmojiesBar}>
                        {calculatePercentage(question.submissions, emojies.length).map((emoji, index) =>
                            <div className={classes.EmojiWrapper} key={index}>
                                <img
                                    className={classes.EmojiReport}
                                    style={{ width: `${emoji.percentage + 20}px` }}
                                    src={emojies[emojies.length - 1 - index]}
                                />
                                <p className={classes.PrecentsText}>{`${Number(emoji.percentage).toFixed(1)}%`}</p>
                            </div>
                        )}
                    </div>
                </div>)

        default:
            return null
    }

}

export default ReflectionEmojiType
